module.exports = "/fonts/vendor/@fontsource/inter/files/inter-cyrillic-ext-800-normal.woff2?9e9fd431c354fbdac3dffac02fad6a96";